import React from 'react';
import PropTypes from 'prop-types';

import {Tabs} from 'reakit'
import {Flex} from "rebass";
import {DesktopBox, TabHeader} from "../../components/Base";
import ConfigurationsPanel from './Configurations'

const FacultySettings = props => {
	const {
		handleSubmitLeaveType, handleSubmitTransport, handleSubmitLocation, handleSubmitInterest, handleSubmitStudent, handleSubmitFaculty, handleSubmitParent,
		handleUpdateLeaveType, handleUpdateTransport, handleUpdateLocation, handleUpdateInterest, handleUpdateStudent, handleUpdateFaculty,	handleUpdateParent,
		leaveTypes, transportation, locations, interests, students, faculties, parents, profile
	} = props;

	return (
		<div>
			<DesktopBox>
			<Tabs.Container>
				{(tabs) =>
					(
						<Flex flexDirection={'row'} flexWrap={'wrap'}>
							<Tabs>
								{profile && profile.is_admin && (
									<Tabs.Tab tab={'config'} {...tabs}>
										<TabHeader title={'Configurations'}/>
									</Tabs.Tab>
								)}
							</Tabs>

							{
								profile && profile.is_admin && (
								<ConfigurationsPanel
									locations={locations}
									interests={interests}
									transportation={transportation}
									leaveTypes={leaveTypes}
									students={students}
									faculties={faculties}
									parents={parents}
									handleSubmitLeaveType={handleSubmitLeaveType}
									handleSubmitLocation={handleSubmitLocation}
									handleSubmitTransport={handleSubmitTransport}
									handleSubmitInterest={handleSubmitInterest}
									handleSubmitStudent={handleSubmitStudent}
									handleSubmitFaculty={handleSubmitFaculty}
									handleSubmitParent={handleSubmitParent}
									handleUpdateInterest={handleUpdateInterest}
									handleUpdateLeaveType={handleUpdateLeaveType}
									handleUpdateLocation={handleUpdateLocation}
									handleUpdateTransport={handleUpdateTransport}
									handleUpdateStudent={handleUpdateStudent}
									handleUpdateFaculty={handleUpdateFaculty}
									handleUpdateParent={handleUpdateParent}
								/>
								)
							}
						</Flex>
					)}
			</Tabs.Container>

			</DesktopBox>
		</div>
	);
};

FacultySettings.propTypes = {
	school: PropTypes.object,
	profile: PropTypes.object,
	updateRequestNotification: PropTypes.func,

	// ConfigurationPanel Props
	handleSubmitLeaveType: PropTypes.func,
	handleSubmitTransport: PropTypes.func,
	handleSubmitLocation: PropTypes.func,
	handleSubmitInterest: PropTypes.func,
	handleSubmitStudent: PropTypes.func,
	handleSubmitFaculty: PropTypes.func,
	handleSubmitParent: PropTypes.func,
	handleUpdateLeaveType: PropTypes.func,
	handleUpdateTransport: PropTypes.func,
	handleUpdateLocation: PropTypes.func,
	handleUpdateInterest: PropTypes.func,
	handleUpdateStudent: PropTypes.func,
	handleUpdateFaculty: PropTypes.func,
	handleUpdateParent: PropTypes.func,
	leaveTypes: PropTypes.array,
	transportation: PropTypes.array,
	locations: PropTypes.array,
	interests: PropTypes.array
};

FacultySettings.defaultProps = {

	// ConfigurationPanel Props
	handleSubmitLeaveType: (values) => console.log(values),
	handleSubmitTransport: (values) => console.log(values),
	handleSubmitLocation: (values) => console.log(values),
	handleSubmitInterest: (values) => console.log(values),
	handleSubmitStudent: (values) => console.log(values),
	handleSubmitFaculty: (values) => console.log(values),
	handleUpdateLeaveType: (values) => console.log(values),
	handleUpdateTransport: (values) => console.log(values),
	handleUpdateLocation: (values) => console.log(values),
	handleUpdateInterest: (values) => console.log(values),
	handleUpdateStudent: (values) => console.log(values),
	handleUpdateFaculty: (values) => console.log(values),
};

export default FacultySettings;
